import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Award, Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { MainLayout } from '../../components/layout/MainLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { CertificateView } from '../../components/certificate/CertificateView';
import { insideSalesCertificate } from '../../components/certificate/certificateContent';

export default function InsideSalesCertificate() {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, cert: null, error: null });

  useEffect(() => {
    api.get('/inside-sales/certificate')
      .then((r) => setState({ loading: false, cert: r.data, error: null }))
      .catch((e) => setState({ loading: false, cert: null, error: e.response?.data?.detail || 'Could not load your certificate' }));
  }, [api]);

  return (
    <MainLayout>
      <div className="mx-auto max-w-5xl space-y-6 p-6" data-testid="inside-sales-certificate-page">
        <Button variant="ghost" onClick={() => navigate('/inside-sales')} data-testid="inside-sales-certificate-back">
          <ArrowLeft className="mr-2 h-4 w-4" />Back to Inside Sales
        </Button>
        {state.loading ? (
          <div className="flex h-96 items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
        ) : state.error ? (
          <Card data-testid="certificate-unavailable">
            <CardContent className="flex flex-col items-center py-16 text-center">
              <Award className="h-14 w-14 text-muted-foreground/50" />
              <h2 className="mt-4 font-heading text-xl font-semibold">Certificate not available yet</h2>
              <p className="mt-1 text-muted-foreground">{state.error}</p>
              <Button className="mt-6" onClick={() => navigate('/inside-sales')}>Continue training</Button>
            </CardContent>
          </Card>
        ) : (
          <CertificateView data={insideSalesCertificate(state.cert)} />
        )}
      </div>
    </MainLayout>
  );
}
